/*jshint esversion: 6 */

import $ from 'jquery';

function mainNavigation() {

  console.log('mainNavigation');

  $('.page-header__shop-navigation >ul >li.menu-item-has-children').prepend('<span class="before-icon"></span>');
  $('.page-header__shop-navigation >ul >li.menu-item-has-children >.before-icon').on('click', event => {
    let $icon = $(event.currentTarget);
    let $li = $icon.parent();
    let $ul = $li.find('>ul');

    $li.toggleClass('open');
    $ul.slideToggle();
  });

  $('.page-header__shop-navigation .sub-menu >li.menu-item-has-children').prepend('<span class="before-icon"></span>');
  $('.page-header__shop-navigation .sub-menu >li >.before-icon').on('click', event => {
    let $icon = $(event.currentTarget);
    let $li = $icon.parent();
    let $ul = $li.find('>ul');

    $li.toggleClass('open');
    $ul.slideToggle();
  });
}

export default mainNavigation;
